import React from 'react';
import Probelisting from '../../../components/probes/probelisting';

function Probes() {
  return <Probelisting />;
}

export default Probes;
